export default "__VITE_ASSET__71c44372__"